import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import testicon from '@assets/icons'
import { parseMarginOrPadding } from '@styles/helper'

const CardIcon = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: grid;
  background: #F6F8FE;
  place-items: center;
  margin: 0 0.25rem;
`

const IconComponent = ({ name, className, card, ...rest }) => {
  const icon = testicon[`icon-${name}`]
  return card ? 
      (<CardIcon>
        <img src={icon} className={`${className} icon-${name}`} {...rest} alt={name + " icon"}/>
      </CardIcon>)
    :
      (<img src={icon} className={`${className} icon-${name}`} {...rest} alt={name + " icon"}/>)
    // <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className={`${className} icon-${name}`}  width={size + "rem"} height={size + "rem"} {...rest}>
    //   <use xlinkHref={`${Iconssvg}#icon-${name}`} />
    // </svg>
}

IconComponent.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  card: PropTypes.bool
}



const Icon = styled(IconComponent)`
  display: grid;
  place-items: center;
  margin: ${(props) => parseMarginOrPadding(props.margin)};
  width: ${(props) => props.size || 1}rem;
  height: ${(props) => props.size || 1}rem;

  fill: ${(props) => props.color};

  svg,
  path {
    fill: inherit;
    background-color: ${(props) => props.color};
  }
`

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.number,
  card: PropTypes.bool
}

export default Icon
